import { getLocale } from '@libs/constants';
import { EXTERNAL_LINKS } from '@libs/redirect.helper';
import { useRouter } from 'next/router';

interface CopperModalContentProps {
  sku: string;
  iproProdID?: string;
  iproPrgrID?: string;
}

export const CopperModalContent = ({ sku, iproPrgrID, iproProdID }: CopperModalContentProps) => {
  const router = useRouter();
  const locale = getLocale(router);
  return (
    <iframe
      data-testid="buybox-copper-modal-iframe"
      src={EXTERNAL_LINKS.COPPER_CALC(sku, iproProdID ?? '', iproPrgrID ?? '', locale)}
      style={{ border: 'medium none', padding: '0px', margin: '0px', width: '730px', height: '469px' }}
      scrolling="yes"
      frameBorder="0"
    />
  );
};
